import { get, flow, isEqual } from 'lodash/fp';
import { createSelector } from 'reselect';

export const getMainSettings = get('settings.main');

export const getMainSettingsData = createSelector(getMainSettings, get('data'));

export const getShowBarcodeSearch = createSelector(
  getMainSettingsData,
  flow(
    get('barcode'),
    isEqual('1')
  )
);

export const getIsHouseholdDetails = createSelector(
  getMainSettingsData,
  flow(
    get('guestAdditionalOthersAtHome'),
    isEqual('1')
  )
);

export const getIsAgeBreakdown = createSelector(
  getMainSettingsData,
  flow(
    get('guestAdditionalOthersAtHome'),
    isEqual('2')
  )
);

export const getIsEnabledAgeBreakdown = createSelector(
  getMainSettingsData,
  flow(
    get('guestOtherAgeHH'),
    isEqual('1')
  )
);

export const getIsShowReservationEmail = createSelector(
  getMainSettingsData,
  flow(
    get('reservationShowEmail'),
    isEqual('1')
  )
);

export const getIsFetching = createSelector(getMainSettings, get('fetching'));
export const getIsFetched = createSelector(getMainSettings, get('fetched'));
export const getFetchingError = createSelector(
  getMainSettings,
  get('fetchingError')
);
